import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeContext.tsx';
import { AlertProvider } from '@/context/AlertContext.tsx';
import { AuthProvider } from '@/context/AuthContext.tsx';
import { FeedbackProvider } from '@/context/FeedbackContext.tsx';
import { SidebarProvider } from '@/context/SidebarContext.tsx';
import Alert from '@/components/shared/Alert.tsx';
import CookieConsentBanner from '@/components/privacy/CookieConsentBanner.tsx';
import { router } from '@/router.tsx';

export default function App() {
  return (
    <ThemeProvider>
      <AlertProvider>
        <AuthProvider>
          <FeedbackProvider>
            <SidebarProvider>
              <Alert />
              <RouterProvider router={router} />
              <CookieConsentBanner />
            </SidebarProvider>
          </FeedbackProvider>
        </AuthProvider>
      </AlertProvider>
    </ThemeProvider>
  );
}
